import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/settings/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
